import api from './api';
const FileDownload = require('js-file-download');

export const getOwnerApplications = async (params) => {
  const response = await api.request({
    method: 'get',
    url: '/application',
    params: params
  });
  return response.data;
};

export const createApplication = async (typeId, companyName, symbol, data) => {
  const response = await api.request({
    method: 'post',
    url: '/app-portal/application/create',
    params: {
      typeId: typeId,
      companyName,
      symbol
    },
    data: data
  });
  return response.data;
};

export const getUserApplications = async () => {
  const response = await api.request({
    method: 'get',
    url: '/app-portal/application'
  });
  return response.data;
};

export const getApplication = async (id) => {
  const response = await api.request({
    method: 'get',
    url: `/app-portal/application/${id}`
  });
  return response.data;
};

export const updateApplication = async (data) => {
  const response = await api.request({
    method: 'put',
    url: '/app-portal/application/update',
    data: data
  });
  return response.data;
};

export const submitApplication = async (appId, data) => {
  const response = await api.request({
    method: 'post',
    url: `/app-portal/application/submit`,
    data: data
  });
  return response.data;
};

export const downloadApplication = async (appId) => {
  const response = await api.request({
    method: 'get',
    url: `/app-portal/application/${appId}/download`,
    responseType: 'blob'
  });

  const header = response && response.headers['content-disposition'];
  const filename = header.split('filename=')[1] || 'OTC Gateway.pdf';
  FileDownload(response.data, filename);
  return true;
};

export const cancelApplication = async (appId) => {
  const response = await api.request({
    method: 'post',
    url: `/app-portal/application/${appId}/cancel`
  });
  return response.data;
};

export const getApplicationOwners = async (appId) => {
  const response = await api.request({
    method: 'get',
    url: `/app-portal/application/${appId}/owners`
  });
  return response.data;
};

export const inviteNewOwner = async (appId, data) => {
  const response = await api.request({
    method: 'post',
    url: `/app-portal/application/${appId}/owners/invite`,
    data
  });
  return response.data;
};

export const deleteOwner = async (appId, removerId, removedOwnerId) => {
  const response = await api.request({
    method: 'delete',
    url: `/app-portal/application/${appId}/owners/remove`,
    params: {
      removerId,
      removedOwnerId
    }
  });
  return response.data;
};

export const uploadApplicationPDF = async (file, filename) => {
  var fd = new FormData();
  fd.append('file', file, filename);

  const response = await api.request({
    method: 'put',
    url: `/app-portal/document/upload/application?filename=${filename}`,
    data: fd
  });
  return response.data;
};

export const downloadPaymentReceipt = async (appId) => {
  const response = await api.request({
    method: 'get',
    url: `/app-portal/application/${appId}/receipt/download`,
    responseType: 'blob'
  });

  const header = response && response.headers['content-disposition'];
  const filename = header.split('filename=')[1] || 'Receipt.pdf';
  FileDownload(response.data, filename);
  return true;
};
